import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Avatar,
  Button,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  AccountBox,
  AdminPanelSettings,
  DarkMode,
  LightMode,
  Logout,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useAppSelector, useUser } from "../../app/hooks";
import { Role } from "../../app/backendTypes";
import ThemeSwitch from "./ThemeSwitch";

function User() {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const adminItems = [];
  const userId = useAppSelector((state) => state.auth.userId);
  const { user } = useUser(userId);
  const roles = useAppSelector((state) => state.auth.roles);


  if (roles.includes(Role.Administrator) || roles.includes(Role.Security)) {
    adminItems.push([
      <MenuItem component={RouterLink} to="admin" onClick={handleClose}>
        <ListItemIcon>
          <AdminPanelSettings color="error" />
        </ListItemIcon>
        Admin
      </MenuItem>,
      <Divider />,
    ]);
  }

  return (
    <>
      <Button onClick={handleOpen}>
        <Avatar sx={{ bgcolor: theme.palette.primary.main }} variant="rounded">
          {extractInitial(user?.employee.firstName)}
          {extractInitial(user?.employee.lastName)}
        </Avatar>
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {adminItems}
        <MenuItem component={RouterLink} to="profile" onClick={handleClose}>
          <ListItemIcon>
            <AccountBox color="secondary" />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem component={RouterLink} to="logout" onClick={handleClose}>
          <ListItemIcon>
            <Logout color="disabled" />
          </ListItemIcon>
          Logout
        </MenuItem>
        <Divider />
        <MenuItem>
          <ListItemIcon>
            <LightMode
              color={theme.palette.mode === "light" ? "warning" : "warning"}
            />
          </ListItemIcon>
          <ThemeSwitch />
          <ListItemIcon>
            <DarkMode color={theme.palette.mode === "dark" ? "info" : "info"} />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </>
  );
}

export default User;

function extractInitial(input: string | undefined) {
  if (input === undefined || input.length === 0) return "?";

  return input[0];
}
